// Vuex event definitions
export const SESSION_RUN = 'Session::run';
export const SESSION_STOP = 'Session::stop';
export const SESSION_CREATED = 'Workspace::created';
export const SESSION_DOWNLOAD = 'Session::download';

// Vue event definitions
export const TUTORIAL_FETCHED = 'Tutorial::fetched';
export const TUTORIAL_ANY_PAGE_MISSIONS_COMPLETED =
  'Tutorial/Page/Missions::completed';
export const TUTORIAL_PAGE_LOADED = 'Tutorial/Page::loaded';
export const TUTORIAL_PAGE_ASYNC_BLOCK = 'Tutorial/Page::async-block';
export const TUTORIALSTATE_AND_SOLUTION_FETCH_FINISHED =
  'TutorialState,Solution::fetched';

// coupon modal
export const COUPON_MODAL_SHOW = 'CouponModal::show';
export const COUPON_MODAL_HIDE = 'CouponModal::hide';
// error modal
export const ERROR_MODAL_SHOW = 'ErrorModal::show';
export const ERROR_MODAL_HIDE = 'ErrorModal::hide';
// learn modal
export const LEARN_MODAL_SHOW = 'LearnModal::show';
export const LEARN_MODAL_HIDE = 'LearnModal::hide';

// utils
export const CLOSE_OTHER_MODALS = 'CLOSE_OTHER_MODALS';

// Request errors
export const REQUEST_FAILED = 'ApiRequest::FAILED';

// Tutorial Container
export const TUTORIAL_CONTAINER_SCROLL = 'TutorialContainer::SCROLL';
